import { DAM, DAM_OPTIONS } from '@constants';
import { Transformation } from '@services';
import { CloudinaryIntegration } from './integrations/cloudinary';
export class ImageTransformation {
  private readonly damIntegration;

  constructor() {
    if (DAM === DAM_OPTIONS.CLOUDINARY) {
      this.damIntegration = new CloudinaryIntegration();
    }
  }

  transformVideoById(id: string | undefined, transformations: Transformation[], fallbackUrl = ''): string {
    return this.damIntegration && id ? this.damIntegration.transformVideoById(id, transformations, fallbackUrl) : fallbackUrl;
  }

  transformVideo(videoURL: string, transformations: Transformation[]): string {
    return this.damIntegration ? this.damIntegration.transformVideo(videoURL, transformations) : videoURL;
  }

  transformById(id: string | undefined, transformations: Transformation[], fallbackUrl = ''): string {
    return this.damIntegration && id ? this.damIntegration.transformById(id, transformations, fallbackUrl) : fallbackUrl;
  }

  transform(image: string, transformations: Transformation[]): string {
    return this.damIntegration ? this.damIntegration.transform(image, transformations) : image;
  }
}
